/* ============================================================
   VEREDELUNGS-AUSWAHL · Lieblingscap
   Schaltet zwischen Stickerei- und DTF-Panel um (nur wenn ein
   Produkt beide Veredelungsarten anbietet, siehe
   snippets/veredelung-auswahl.liquid). Reine Sichtbarkeits- und
   Absenden-Steuerung - die eigentliche Feldlogik bleibt vollstaendig
   in stickerei-karte.js / wunschlogo-karte.js / dtf-optionen.js.
   ============================================================ */
(function () {
  'use strict';

  /* Liegt ein Feld in einem .va-panel, das selbst (oder eines seiner
     Vorfahren-Panels bei verschachtelten Umschaltern) gerade
     ausgeblendet ist? Prueft die ganze Vorfahren-Kette, nicht nur das
     naechstliegende .va-panel - siehe Kommentar bei pruefeAktiv(). */
  function istInVerstecktemPanel(el) {
    var panel = el.closest('.va-panel');
    while (panel) {
      if (panel.hidden) return true;
      var eltern = panel.parentElement;
      panel = eltern ? eltern.closest('.va-panel') : null;
    }
    return false;
  }

  /* Deaktiviert alle benannten Formularfelder in ausgeblendeten
     Panels, damit sie beim Absenden NICHT als line item properties
     mitgeschickt werden (deaktivierte Felder werden von Browsern nie
     submittet - anders als nur unsichtbare). Ohne das landeten z. B.
     bei DTF trotzdem die Stickerei-Felder (Garnfarbe, Schriftart...)
     im Warenkorb, weil sie nur per CSS/hidden-Attribut versteckt,
     aber nicht wirklich deaktiviert waren. Global statt pro Wrapper,
     damit sich verschachtelte Umschalter (aussen Stickerei/DTF,
     innen Wunschtext/Wunschlogo) gegenseitig korrekt beruecksichtigen,
     egal welcher der beiden Wrapper zuletzt seine eigene Sichtbarkeit
     geaendert hat. */
  function aktualisiereFelder() {
    document
      .querySelectorAll('[data-va-wrapper] input[name], [data-va-wrapper] select[name], [data-va-wrapper] textarea[name]')
      .forEach(function (feld) {
        feld.disabled = istInVerstecktemPanel(feld);
      });
  }

  /* Blendet den dynamischen Bezahlbutton (PayPal etc., siehe
     buy-buttons.liquid #lc-dynamic-checkout-<section_id>) aus, sobald
     im Formular gerade ein SICHTBARER Datei-Upload steht - unabhaengig
     davon, welcher der (ggf. verschachtelten) Umschalter das gerade
     zeigt. Grund: Ajax-basierte Bezahlbuttons koennen keine Dateien
     uebertragen (siehe Kommentar in buy-buttons.liquid). Bei reiner
     Textwahl bleibt der Button unangetastet sichtbar. */
  function aktualisierePaypal() {
    document.querySelectorAll('[id^="lc-dynamic-checkout-"]').forEach(function (wrapper) {
      var form = wrapper.closest('form');
      if (!form) return;
      var hatSichtbareDatei = false;
      form.querySelectorAll('input[type=file]').forEach(function (datei) {
        if (!istInVerstecktemPanel(datei)) hatSichtbareDatei = true;
      });
      wrapper.hidden = hatSichtbareDatei;
    });
  }

  function initVA(wrapper) {
    if (wrapper.dataset.vaInit) return;
    wrapper.dataset.vaInit = '1';

    /* Generisch gehalten: welches properties[...]-Feld die Radios nutzen
       und welche Werte sie haben, ist egal - massgeblich ist nur das
       data-panel-Attribut auf jedem Radio, das zum data-va-panel des
       zugehoerigen Panels passt. So laesst sich derselbe Umschalter
       fuer "Stickerei/DTF" UND fuer "Wunschtext/Wunschlogo"
       (personalisierungs_stil == 'wahl') wiederverwenden.

       ":scope >" statt einer normalen Suche: ein Panel kann selbst
       wieder einen kompletten va-wrapper enthalten (Produkt hat
       gleichzeitig Stickerei/DTF UND Wunschtext/Wunschlogo). Ohne
       ":scope >" wuerden sich die Radios/Panels des inneren und
       aeusseren Umschalters gegenseitig einsammeln. */
    var radios = wrapper.querySelectorAll(':scope > .va-block .va-seg input[type="radio"][data-panel]');
    var panels = wrapper.querySelectorAll(':scope > .va-panel');
    var form = wrapper.closest('form');

    function aktivesPanel() {
      var gewaehlt = null;
      radios.forEach(function (r) {
        if (r.checked) gewaehlt = r.dataset.panel;
      });
      if (!gewaehlt && radios.length) gewaehlt = radios[0].dataset.panel;
      return gewaehlt;
    }

    /* Der Absenden-Knopf wird von der jeweils eingeblendeten Karte
       selbst mitgesteuert (stickerei-karte.js / wunschlogo-karte.js /
       dtf-optionen.js pruefen das ueber .va-panel[hidden] - siehe
       Guard in ihrer jeweiligen pruefe()-Funktion). Hier zusaetzlich
       eine zweite, verlaessliche Instanz: nach jeder Interaktion
       direkt aus der Fehlerliste (.va-blocker-liste) der gerade
       aktiven Karte ablesen, ob der Knopf gesperrt werden muss -
       unabhaengig davon, ob die fremde Karte selbst gerade neu
       gerendert hat.

       Bei verschachtelten Umschaltern (siehe oben) kann das aktive
       Panel MEHRERE Fehlerlisten enthalten (eine je verschachtelter
       Karte) - nur die zaehlen, deren eigenes naechstliegendes Panel
       gerade sichtbar ist. */
    function pruefeAktiv() {
      /* Liegt dieser ganze Umschalter (z. B. der innere Wunschtext/
         Wunschlogo-Wechsel) selbst in einem gerade ausgeblendeten
         Panel eines AEUSSEREN Umschalters (z. B. weil DTF statt
         Stickerei gewaehlt ist), darf er den Kaufen-Button gar nicht
         anfassen - sonst blockieren Pflichtfelder einer Karte, die
         der Kunde nie sieht, den Kauf ueber die andere Karte. */
      var elternPanel = wrapper.parentElement ? wrapper.parentElement.closest('.va-panel') : null;
      if (elternPanel && elternPanel.hidden) return;

      var aktiv = aktivesPanel();
      var panel = wrapper.querySelector(':scope > .va-panel[data-va-panel="' + aktiv + '"]');
      if (!panel || !form) return;
      var hatProbleme = false;
      panel.querySelectorAll('.va-blocker-liste').forEach(function (liste) {
        var eigenesPanel = liste.closest('.va-panel');
        if (eigenesPanel && eigenesPanel.hidden) return;
        if (liste.children.length > 0) hatProbleme = true;
      });
      form.querySelectorAll('[type=submit], .product-form__submit').forEach(function (btn) {
        btn.disabled = hatProbleme;
      });
    }

    function zeigePanel() {
      var aktiv = aktivesPanel();
      panels.forEach(function (p) {
        p.hidden = p.dataset.vaPanel !== aktiv;
      });
      aktualisiereFelder();
      aktualisierePaypal();
      pruefeAktiv();
    }

    radios.forEach(function (r) {
      r.addEventListener('change', zeigePanel);
    });

    if (form) {
      ['input', 'change', 'click'].forEach(function (art) {
        form.addEventListener(art, function () {
          window.setTimeout(pruefeAktiv, 0);
        });
      });
    }

    zeigePanel();
  }

  function boot() {
    document.querySelectorAll('[data-va-wrapper]').forEach(initVA);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('[data-va-wrapper]') : null;
    if (el) initVA(el);
  });
})();
